module.exports = __webpack_public_path__ + "static/media/RM007_COVER1_FORPRINT_compressed-17.f6ee6934.jpg";